// removed by extract-text-webpack-plugin
module.exports = {"supportCard":"SupportCategoryCard_supportCard_2pQ5n","icon":"SupportCategoryCard_icon_3G9t3"};


//////////////////
// WEBPACK FOOTER
// ./src/docs/examples/CategoryCard/SupportCategoryCard.css
// module id = 26
// module chunks = 0